import { render, staticRenderFns } from "./AppList.vue?vue&type=template&id=fde5dce4&"
import script from "./AppList.vue?vue&type=script&lang=ts&"
export * from "./AppList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports